export const logotipo = () => {
    return localStorage.getItem("roc-virtualPath") + "logo.png";    
}

export const logoSecundario = () => {
    return localStorage.getItem("roc-virtualPath") + "logoSecundario.png";
}

export const logotipoBranco = () => {
    return localStorage.getItem("roc-virtualPath") + "logoBranco.png";
}

export const logoSecretariaBranco = () => {
    return localStorage.getItem("roc-virtualPath") + "logoSecretariaBranco.png";
}